export class VerbConjugation {
    constructor(
      public verb: string,
      public conjugations: (string | string[])[] // can be string or [ra, se]
    ) {}
  }
  